<template>
    <div class="holder">
        <div class="flex-row" v-if="model && model.condominium_name">
            <div class="flex-col-0" style="width: 100%; max-width: 400px">
                <form-fake-text :disabled="true" :model.sync="model.condominium_name">
                    <div slot="label">
                        Nome do condominío
                        <i title="Esse campo será removido em breve e migrado para seu respectivo Condominio ou Empreendimento" class="fa fa-exclamation-circle required-icon" v-tooltip></i>
                    </div>
                </form-fake-text>
            </div>
            <div class="flex-col-0" style="flex-shrink: 0">
                <div class="fake-label-margin">
                    <button @click="model.condominium_name = null" class="btn btn-danger" v-tooltip title="Isso não removerá o valor dos outros imóveis.">
                        <i class="fa fa-trash"></i>
                        Limpar valor
                    </button>
                </div>
            </div>
            <div class="flex-col-0" style="flex-shrink: 0">
                <div class="alert alert-info fake-label-margin" style="padding: 6px 12px" @click="$refs.select.focus()">
                    <i class="fa fa-info-circle"></i>
                    Utilize o campo abaixo para selecionar um Condomínio/Empreendimento ou cadastra-lo
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-7">
                <form-remote-select v-ref:select
                                    :model.sync="model.building_id"
                                    url="/buildings"
                                    :query="{sort: {updated_at: null, draft: null, name: 'asc'}, presenter: 'simple-presenter'}"
                                    :template-result="formatBuildingResult"
                                    :template-selection="formatBuildingSelection"
                                    :on-prefetched="buildingSelected"
                                    :last-options="buildingsLastOptions">
                    <div slot="label">
                        Condomínio/Empreendimento
                        <a :href="buildingUrl()" class="pull-right" target="_blank" v-if="model.building_id">
                            Ver
                            <i class="fa fa-external-link"></i>
                        </a>
                    </div>
                </form-remote-select>
            </div>
            <div class="col-xs-5">
                <div v-if="model.building && model.building.type === 2">
                    <div v-if="ui.unitLoaded">
                        <div v-if="model.unit">
                            <form-fake-text :disabled="true" label="Unidade" :model.sync="model.unit.name"></form-fake-text>
                        </div>

                        <div v-if="!model.unit">
                            <label>
                                Unidade
                                <i title="Caso um imóvel esteja associado com um <br /> Empreendimento, ele deve estar associado a uma unidade também." class="fa fa-exclamation-circle required-icon" v-tooltip></i>
                            </label>
                            <div>
                                <button type="button" class="btn blue pull-left" @click="showUnitPicker()">Associar Unidade</button>
                                <i v-if="model.create_unit" title="Uma unidade será criada quando o imóvel for salvo." class="fa fa-exclamation-circle font-blue" style="padding: 8px" v-tooltip></i>
                                <!--
                                <div v-if="model.create_unit" class="alert alert-info pull-left" style="padding: 6px; margin-left: 5px">
                                    <i class="fa fa-info-circle"></i> Criação pendente.
                                </div>
                                -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ui-modal v-ref:replace-modal>
            <div slot="header">
                Mesclar informações
            </div>

            <div v-if="model.building">
                Deseja mesclar as informações do
                <span class="text-lowercase">{{model.building.user_type}}</span>
                <b>{{model.building.user_code}} - {{model.building.name}}</b> com o imóvel?
            </div>

            <div slot="footer">
                <button type="button" class="btn btn-default" @click="$refs.replaceModal.hide()">Não</button>
                <button type="button" class="btn blue" @click="replace()">Sim</button>
            </div>
        </ui-modal>

        <ui-modal v-ref:unit-picker-modal :width="1000" :backdrop-clickable="false">
            <div style="padding: 20px">
                <ui-loading :state="ui.loadingOptions || ui.loadingBuilding || ui.loadingTowers">
                    <div v-if="ui.savingProperty">
                        <div class="text-center">
                            <div style="font-weight: 400; font-size: 24px; margin: 0 auto 15px;">
                                Substituindo as informações do imóvel...
                            </div>
                            <div style="font-weight: 300; font-size: 20px;">
                                Isso pode levar alguns instantes, a pagina será recarregada quando completo.
                            </div>
                        </div>
                    </div>
                    <div v-if="!ui.loadingOptions && !ui.loadingBuilding && !ui.loadingTowers && !ui.savingProperty">
                        <button class="new-close" type="button" @click="cancelSelection()" v-tooltip title="Cancelar">
                            &times;
                        </button>
                        <div v-if="towers.length > 0">
                            <h2 class="text-center" style="font-size: 24px; width: 70%; margin: 0 auto; margin-bottom: 50px;">
                                Olá, identificamos que este prédio possui
                                <b>torres</b> e <b>tipos de unidades</b>,
                                selecione a que corresponde ao seu imóvel.
                            </h2>

                            <div>
                                <div class="flex-row">
                                    <div style="padding: 0 10px">
                                        <img src="/assets/images/apartment.svg" style="width: 75px" />
                                    </div>
                                    <div class="flex-col-12">
                                        <h4><b>Torres</b></h4>
                                        <div class="row">
                                            <div class="col-xs-3" v-for="t in towers" style="margin-bottom: 15px">
                                                <form-radio :value="t"
                                                            name="building-select.tower"
                                                            :model.sync="tower"
                                                            :label="t.name"
                                                            type="square"></form-radio>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <hr>

                            <div v-if="units !== null">
                                <ui-loading :state="ui.loadingUnits">
                                    <div class="flex-row">
                                        <div style="padding: 0 10px">
                                            <img src="/assets/images/blueprint.svg" style="width: 75px" />
                                        </div>
                                        <div class="flex-col-12">
                                            <h4><b>Unidades da Torre</b></h4>
                                            <div class="row">
                                                <div class="col-xs-3" v-for="u in units" style="padding: 15px;" @click="unit = u">
                                                    <div style="background-color: #EFEFEF; cursor: pointer; padding: 8px; border-radius: 4px;">
                                                        <div style="margin-bottom: 10px; font-size: 14px;">
                                                            {{ u.name }}
                                                        </div>
                                                        <div style="margin-bottom: 8px; font-size: 12px; max-height: 52px; height: 52px">
                                                            {{ u.lines.first }}
                                                        </div>
                                                        <div>
                                                            <form-radio :value="u"
                                                                    name="building-select.unit"
                                                                    :model.sync="unit"
                                                                    label="Usar este"
                                                                    type="square"></form-radio>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xs-3" style="padding: 15px;" v-if="!$can('edit.buildings')">
                                                    <div style="background-color: #EEEEEE; cursor: pointer; padding: 8px; border-radius: 4px;">
                                                        <div style="margin-bottom: 10px; font-size: 12px">
                                                            <b>Criar novo tipo de unidade</b>
                                                        </div>
                                                        <div style="margin-bottom: 8px; font-size: 12px; max-height: 52px; height: 52px">
                                                            Você não tem permissão para criar um tipo de unidade.
                                                        </div>
                                                        <div>
                                                            &nbsp;
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xs-3" style="padding: 15px;" v-if="$can('edit.buildings')" @click="unit = null">
                                                    <div style="background-color: #EEEEEE; cursor: pointer; padding: 8px; border-radius: 4px;">
                                                        <div style="margin-bottom: 10px; font-size: 12px">
                                                            <b>Criar novo tipo de unidade</b>
                                                        </div>
                                                        <div style="margin-bottom: 8px; font-size: 12px; max-height: 52px; height: 52px">
                                                            A criação será automática
                                                        </div>
                                                        <div>
                                                            <form-radio :value="null"
                                                                        name="building-select.unit"
                                                                        :model.sync="unit"
                                                                        label="Usar este"
                                                                        type="square"></form-radio>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ui-loading>
                            </div>

                            <div v-if="!ui.loadingUnits" class="text-right" style="margin-top: 15px">
                                <button type="button" v-if="!model.id && unit !== null" class="btn orange" @click="saveWithSilentReplace()"
                                        title="Atrela a unidade ao imóvel,<br/ > substituindo as informações do<br/ > imóvel com as da unidade"
                                        v-tooltip
                                >
                                    Salvar
                                </button>

                                <button type="button" v-if="model.id && unit !== null" class="btn orange" @click="saveWithoutReplace()"
                                        title="Apenas atrela a unidade ao imóvel,<br/ > sem substituir as informações do<br/ > imóvel com as da unidade"
                                        v-tooltip
                                    >
                                    Apenas salvar
                                </button>

                                <button type="button" v-if="model.id && unit !== null" class="btn orange" @click="saveSelectedUnit()"
                                        title="Atrela a unidade ao imóvel,<br/ > substituindo as informações (fotos, características, vídeos e composição ) do<br/ > imóvel com as da unidade"
                                        v-tooltip>
                                    Salvar e substituir
                                </button>

                                <button type="button" v-if="unit === null" class="btn orange" @click="saveSelectedUnit()"
                                        title="Será criada uma unidade com<br/ >base nos dados dados do imóvel"
                                        v-tooltip>
                                    Salvar
                                </button>
                            </div>
                        </div>
                        <div v-if="towers.length < 1 && !$can('edit.buildings')">
                            <h2 class="text-center" style="font-size: 24px; width: 70%; margin: 0 auto; margin-bottom: 50px;">
                                Olá, identificamos que este prédio não possui
                                <b>torres</b> e <b>tipos de unidades</b>,
                                vamos melhorar seu cadastro.
                            </h2>

                            <div>
                                <div class="flex-row">
                                    <div style="padding: 0 20px">
                                        <img src="/assets/images/apartment.svg" style="width: 120px" />
                                    </div>
                                    <div class="flex-col-12">
                                        <h4><b>Torres</b></h4>
                                        <div>
                                            <div class="alert alert-success">
                                                Não existem torres cadastradas e você não possui permissão para criar torres.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="towers.length < 1 && $can('edit.buildings')">
                            <h2 class="text-center" style="font-size: 24px; width: 70%; margin: 0 auto; margin-bottom: 50px;">
                                Olá, identificamos que este prédio não possui
                                <b>torres</b> e <b>tipos de unidades</b>,
                                vamos melhorar seu cadastro.
                            </h2>

                            <div>
                                <div class="flex-row">
                                    <div style="padding: 0 20px">
                                        <img src="/assets/images/apartment.svg" style="width: 120px" />
                                    </div>
                                    <div class="flex-col-12">
                                        <h4><b>Torres</b></h4>
                                        <div>
                                            <div class="alert alert-success">
                                                Não existem torres cadastradas. Por favor preencha os dados abaixo.
                                            </div>

                                            <form action="#" method="POST"
                                                @submit.prevent="saveTower()"
                                                class="form-default"
                                                name="ui.tower"
                                                v-el:tower-form>
                                                <div class="row" v-if="ui.tower">
                                                    <div class="col-md-3">
                                                        <form-text :model.sync="ui.tower.name"
                                                                label="Nome da torre">
                                                        </form-text>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <form-select :options.sync="options.general_statuses"
                                                                    :model.sync="ui.tower.general_status">
                                                            <slot slot="label">
                                                                <span>Status</span>
                                                                <i title="Caso vázio, será utilizado o Status do Empreendimento."
                                                                class="fa fa-info-circle"
                                                                v-tooltip></i>
                                                            </slot>
                                                        </form-select>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <form-numeric :model.sync="ui.tower.floors"
                                                                    label="Andares"
                                                                    :min="0">
                                                        </form-numeric>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <form-numeric :model.sync="ui.tower.real_floors"
                                                                    label="Pavimentos"
                                                                    :min="0">
                                                        </form-numeric>
                                                    </div>
                                                </div>

                                                <div class="text-right" style="margin-top: 15px">
                                                    <button class="btn orange">Cadastrar</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ui-loading>
            </div>
        </ui-modal>

        <!-- MODAL -->
        <ui-modal v-ref:create-modal :width="1000">
            <div slot="header">
                Cadastrar Condomínio/Empreendimento
            </div>
            <div v-if="building">
                <ui-loading :state="ui.loadingOptions" text="Carregando informações...">
                    <form name="building" class="form-default" v-el:form>
                        <div>
                            <form-addressing form="building"
                                             :model.sync="building"
                                             :required="true"
                                             :with-alternative-neighborhood="true"
                                             :with-block="false"
                                             :with-complementary="false"></form-addressing>
                        </div>
                        <hr/>
                        <div>
                            <div class="row">
                                <div class="col-md-3">
                                    <form-select :options.sync="types"
                                                 :model.sync="building.type"
                                                 placement="top">
                                        <slot slot="label">
                                            <span>Tipo</span>
                                            <i title="Obrigatório"
                                               class="fa fa-exclamation-circle required-icon"
                                               v-tooltip></i>
                                        </slot>
                                    </form-select>
                                </div>
                                <div class="col-md-3">
                                    <form-text placeholder="Código alternativo" :model.sync="building.alternative_code">
                                        <slot slot="label">
                                            <span>Código alternativo</span>
                                            <i title="Obrigatório caso seu website esteja marcado com &#34;Exibir código alternativo&#34;"
                                               class="fa fa-exclamation-circle required-icon"
                                               v-tooltip></i>
                                        </slot>
                                    </form-text>
                                </div>
                                <div class="col-md-3">
                                    <form-text :model.sync="building.name" placeholder="Nome">
                                        <slot slot="label">
                                            <span>Nome</span>
                                            <i title="Obrigatório"
                                               class="fa fa-exclamation-circle required-icon"
                                               v-tooltip></i>
                                        </slot>
                                    </form-text>
                                </div>
                                <div class="col-md-3">
                                    <form-select :options.sync="options.finalities"
                                                 :model.sync="building.finality"
                                                 placement="top">
                                        <slot slot="label">
                                            <span>Finalidade</span>
                                            <i title="Obrigatório"
                                               class="fa fa-exclamation-circle required-icon"
                                               v-tooltip></i>
                                        </slot>
                                    </form-select>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <form-select :options.sync="options.general_statuses"
                                                 :model.sync="building.general_status"
                                                 placement="top">
                                        <slot slot="label">
                                            <span>Status</span>
                                            <i title="Obrigatório"
                                               class="fa fa-exclamation-circle required-icon"
                                               v-tooltip></i>
                                        </slot>
                                    </form-select>
                                </div>
                            </div>
                        </div>
                    </form>
                </ui-loading>
            </div>
            <div slot="footer">
                <button class="btn btn-default" type="button" @click="close()">Fechar</button>
                <button class="btn yellow-gold" type="button" @click="saveAndReplace()" title="Substitui as informações do imóvel com as do empreedimento/condomínio<br />cadastrado e atrela o imóvel a ele." v-tooltip>
                    Cadastrar e substituir
                </button>
            </div>
        </ui-modal>
    </div>
</template>
<script>
    const condominiumTemplate = require('templates/ui-condominium-search.html')
    const { vueChaos, client } = require('sci/helpers')
    const { plural } = require('sci/std/string')
    const R = require('ramda')
    const Vue = require('vue')
    const toastr = require('toastr')

    const defaultBuilding = {
        code: null,
        alternative_code: null,
        type: null,
        finality: null,
        general_status: null,
        draft: true,
        zipcode: null,
        state_id: null,
        state: null,
        city: null,
        city_id: null,
        neighborhood: null,
        neighborhood_id: null,
        alternative_neighborhood: null,
        alternative_neighborhood_id: null,
        street: null,
        street_number: null,
        name: null
    }

    const defaultTower = {
        name: null,
        general_status: null,
        real_floors: null,
        floors: null
    }

    const copyProps = R.pick([
        'zipcode',
        'state_id',
        'state',
        'city',
        'city_id',
        'neighborhood',
        'neighborhood_id',
        'alternative_neighborhood',
        'alternative_neighborhood_id',
        'street',
        'street_number',
        'finality',
        'general_status'
    ])

    const copyModel = R.pipe(R.clone, copyProps)

    export default {
        twoWay: true,
        template: condominiumTemplate,
        props: {
            model: {
                twoWay: true,
                type: Object
            },
            onSelected: {
                type: Function
            },
            onReplace: {
                type: Function
            }
        },
        data () {
            return {
                building: R.clone(defaultBuilding),
                options: {
                    types: [],
                    finalities: [],
                    general_statuses: []
                },
                ui: {
                    loadingBuilding: false,
                    loadingTowers: false,
                    loadingUnits: false,
                    loadingOptions: false,
                    tower: R.clone(defaultTower),
                    unitLoaded: false,
                    savingProperty: false
                },
                towers: [],
                units: [],
                tower: null,
                unit: null,
                types: [
                    { id: 1, name: 'Condomínio Fechado' },
                    { id: 2, name: 'Empreendimento / Prédio' }
                ]
            }
        },
        ready () {
            this.loadModelUnitInfo()
        },
        methods: {
            loadModelUnitInfo () {
                if (this.model.building_unit_id && !this.model.unit) {
                    this.ui.unitLoaded = false

                    client.get(
                        `Carregando unidade...`,
                        `/buildings/${this.model.building_id}/units/${this.model.building_unit_id}`
                    ).then(({ data }) => {
                        this.model.unit = data

                        this.ui.unitLoaded = true
                    })
                }

                this.ui.unitLoaded = true
            },
            close () {
                this.$refs.createModal.hide()
            },
            cancelSelection () {
                this.model.building = null
                this.model.building_id = null

                this.$refs.unitPickerModal.hide()
            },
            _save () {
                return client
                    .post('Salvando...', '/buildings', this.building)
                    .then(vueChaos(this.$els.form))
            },
            save () {
                this._save().then((building) => {
                    this.model.building = building
                    this.model.building_id = building.id
                })
            },
            saveAndReplace () {
                this._save().then((building) => {
                    this.model.building = building
                    this.model.building_id = building.id

                    this.model = {
                        ...this.model,
                        condominium_name: null,
                        ...copyModel(building)
                    }

                    this.$refs.createModal.hide()
                })
            },
            open (name) {
                this.building = {
                    ...R.clone(defaultBuilding),
                    ...copyModel(this.model),
                    name
                }

                this.$refs.createModal.show()

                this.loadOptions()
            },
            loadOptions () {
                this.ui.loadingOptions = true

                return client
                    .get(null, '/buildings/search-options')
                    .then(({ data }) => {
                        this.options = data
                        this.ui.loadingOptions = false
                    })
            },
            buildingSelected (id, building) {
                if (building
                    && building.type === 2
                    && building.units_count < 1
                    && building.towers_count < 1
                    && !this.$can('edit.buildings')
                ) {
                    toastr.warning('Não há torres e unidades nesse empreendimento e você não tem permissão para cria-las.')

                    this.towers = []
                    this.unit = null
                    this.tower = null
                    this.building = null
                    this.model.building = null
                    this.model.unit = null
                    this.model.building_id = null
                    this.model.building_unit_id = null

                    return
                }

                if (building
                    && building.type === 2
                    && building.units_count < 1
                    && building.towers_count > 0
                    && !this.$can('edit.buildings')
                ) {
                    toastr.warning('Não há unidades nesse empreendimento e você não tem permissão para criar unidades.')

                    this.towers = []
                    this.unit = null
                    this.tower = null
                    this.building = null
                    this.model.building = null
                    this.model.unit = null
                    this.model.building_id = null
                    this.model.building_unit_id = null

                    return
                }


                this.model.condominium_name = null
                if (!this.model.building || (this.model.building.id !== building.id)) {
                    this.model.building = building
                }

                if (building && building.type === 2 && building.units_count < 1 && building.towers_count > 0) {
                    this.loadTowers().then((towers) => {
                        this.saveSelectedUnit()
                    })
                }
            },
            formatBuildingResult (state, container) {
                if (!state) {
                    return 'Digite o nome...'
                }

                if (state.__create) {
                    const name = state.name || this.model.condominium_name

                    container.classList.add('bg-warning')

                    container.addEventListener('click', () => {
                        this.$refs.select.close()
                        this.open(name)
                    })

                    let statement = ''

                    if (name) {
                        statement = `<b>${name}</b>`
                    }

                    return `
                        <div style="padding: 6px; margin-left: -6px; margin-right: -6px; cursor: pointer">
                            <div>Não encontrou?</div>
                            <button class="btn btn-sm orange" style="margin-top: 4px">CADASTRAR ${statement}</button>
                        </div>
                    `
                }

                const labels = []

                if (state.type === 1) {
                    labels.push('<span class="label label-info">Condomínio</span>')
                } else if (state.type === 2) {
                    labels.push('<span class="label label-info">Empreendimento</span>')
                }

                if (state.properties_count) {
                    labels.push(`<span class="label label-info">${plural(state.properties_count, '%s imóveis', '%s imóvel')}</span>`)
                }

                if (state.towers_count) {
                    labels.push(`<span class="label label-info">${plural(state.towers_count, '%s torres', '%s torre')}</span>`)
                }

                if (state.units_count) {
                    labels.push(`<span class="label label-info">${plural(state.units_count, '%s unidades', '%s unidade')}</span>`)
                }

                let number = '';

                if (state.street_number) {
                    number = `, ${state.street_number}`
                }

                let label = null;

                if (state.city) {
                    label = `${state.name} - ${state.city.name}`
                } else {
                    label = state.name
                }

                return `
                            <div style="padding-bottom: 4px; padding-top: 4px">
                                <div style="margin-bottom: 0px">
                                    <span>${label}</span>
                                </div>
                                <div style="margin-bottom: 8px">${state.street}${number}</div>
                                <div>
                                    ${labels.join(' ')}
                                </div>
                            </div>
                        `
            },
            buildingsLastOptions (result, term) {
                if (this.$can('add.buildings')) {
                    return [
                        {
                            id: -1,
                            disabled: true,
                            __create: true,
                            name: term,
                            text: term
                        }
                    ]
                }

                return []
            },
            processBuildingsResult (result, term) {
                return result
            },
            formatBuildingSelection (item) {
                if (!item) {
                    return 'Digite o nome...'
                }

                let label = null;

                if (item.city) {
                    label = `${item.name} - ${item.city.name}`
                } else {
                    label = `${item.name}`
                }

                if (item.deleted_at) {
                    label = `<span class="label label-xs label-danger">removido</span> ${label}`
                }

                return label
            },
            buildingUrl () {
                if (this.model.building) {
                    switch (String(this.model.building.type)) {
                        case '1':
                            return `/condominiums/${this.model.building_id}`
                        case '2':
                            return `/buildings/${this.model.building_id}`
                    }
                }

                return null
            },
            replace () {
                if (this.model.building) {
                    this.model = {
                        ...this.model,
                        condominium_name: null,
                        ...R.pick([
                            'zipcode',
                            'state_id',
                            'state',
                            'city_id',
                            'city',
                            'neighborhood_id',
                            'neighborhood',
                            'alternative_neighborhood_id',
                            'alternative_neighborhood',
                            'street',
                            'street_number',
                            'zone'
                        ], this.model.building)
                    }

                    if (this.model.building.type === 2) {
                        this.showUnitPicker()
                    }
                }

                this.$refs.replaceModal.hide()
            },
            showUnitPicker () {
                this.loadBuilding()

                this.$refs.unitPickerModal.show()
            },
            loadBuilding () {
                this.loadOptions().then(() => {
                    this.ui.loadingBuilding = true

                    client
                        .get(`Carregando empreendimento...`, `/buildings/${this.model.building_id}`)
                        .then(({ data }) => {
                            this.building = data

                            this.ui.loadingBuilding = false

                            this.loadTowers()
                        })
                })
            },
            loadTowers () {
                this.ui.loadingTowers = true

                return client
                    .get(`Carregando torres...`, `/buildings/${this.model.building_id}/towers`)
                    .then(({ data }) => {
                        this.towers = data

                        this.tower = R.defaultTo(null, R.head(this.towers))

                        this.ui.loadingTowers = false

                        return data
                    })
            },
            loadUnits () {
                this.ui.loadingUnits = true

                client
                    .get(`Carregando torres...`, `/buildings/${this.model.building_id}/towers/${this.tower.id}/units`)
                    .then(({ data }) => {
                        this.units = data

                        this.unit = R.defaultTo(null, R.head(data))

                        this.ui.loadingUnits = false
                    })
            },
            saveTower () {
                client
                    .post(`Salvando torre...`, `/buildings/${this.model.building_id}/towers`, this.ui.tower)
                    .then(vueChaos(this.$els.towerForm))
                    .then((data) => {
                        this.tower = data

                        this.saveSelectedUnit()
                        // this.loadTowers()
                    })
            },
            saveWithoutReplace () {
                return this.saveSelectedUnit(false)
            },
            saveWithSilentReplace () {
                if (this.unit !== null) {
                    this.$set('model.create_unit', null)

                    if (this.tower) {
                        this.model.block = this.tower.name
                    }

                    this.model.building_unit_id = this.unit.id
                    this.model.unit = Vue.util.extend({}, this.unit)
                    this.model.portal_street_number = this.building.portal_street_number
                    this.$refs.unitPickerModal.hide()

                    this.$set('model.create_with_unit', this.unit.id)
                }
            },
            saveSelectedUnit (replace = true) {
                if (this.unit !== null) {
                    this.$set('model.create_unit', null)

                    if (this.tower) {
                        this.model.block = this.tower.name
                    }

                    if (!replace) {
                        this.model.building_unit_id = this.unit.id
                        this.model.unit = Vue.util.extend({}, this.unit)

                        this.$refs.unitPickerModal.hide()
                        return
                    }

                    this.ui.savingProperty = true

                    if (this.model.id) {
                        client
                            .put(`Salvando...`, `/properties/${this.model.id}/replace-with-unit/${this.unit.id}`)
                            .then(({ data }) => {
                                // this.$refs.unitPickerModal.hide()

                                if (this.onReplace) {
                                    this.onReplace(data)
                                }
                            })
                    } else {
                        client
                            .post(`Salvando...`, `/buildings/${this.model.building_id}/units/${this.unit.id}/generate-property`, {
                                with_complementary: false
                            })
                            .then(({ data }) => {
                                // this.$refs.unitPickerModal.hide()

                                if (this.onReplace) {
                                    this.onReplace(data)
                                }
                            })
                    }
                } else {
                    this.model = {
                        ...this.model,
                        ...R.pick([
                            'zipcode',
                            'state_id',
                            'state',
                            'city_id',
                            'city',
                            'neighborhood_id',
                            'neighborhood',
                            'alternative_neighborhood_id',
                            'alternative_neighborhood',
                            'street',
                            'street_number',
                            'zone',
                            'general_status'
                        ], this.model.building)
                    }

                    if (this.tower) {
                        this.model.block = this.tower.name

                        if (this.tower.general_status) {
                            this.model.general_status = this.tower.general_status
                        }
                    }

                    this.$refs.unitPickerModal.hide()

                    this.$set('model.create_unit', {
                        building_tower_id: this.tower.id
                    })
                }
            }
        },
        watch: {
            'tower' (newVal) {
                if (!newVal) {
                    this.units = [];
                    return
                }

                this.loadUnits()
            },
            'model.building_id' (newVal) {
                if (!newVal) {
                    this.model.building = null
                }

                this.model.unit = null
                this.model.building_unit_id = null
            },
            'model.building' (newVal, oldVal) {
                if (!newVal) {
                    return
                }

                if (oldVal && newVal.id === oldVal.id) {
                    return
                }

                if (newVal && newVal.units_count < 1 && newVal.towers_count > 0) {
                    this.loadTowers().then((towers) => {
                        this.saveSelectedUnit()
                    })

                    return
                }

                if (this.model && this.model.id) {
                    if (newVal.type === 1) {
                        this.$refs.replaceModal.show()
                    } else {
                        this.showUnitPicker()
                    }
                } else {
                    this.replace()
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Select.vue?264f90eb